export default __webpack_public_path__ + "assets/images/decor.784ae0.png";